/**
 * Host helpers for goodleap.plus vanity domains (same SPA / CloudFront as goodleap.dev).
 *
 * - goodleap.plus / www.goodleap.plus → marketing home at `/`, apply at `/:id`
 * - financing.goodleap.plus → Financing+ Toolkit at `/`, apply at `/:id` (same apply as goodleap.plus)
 */

function hostname() {
  if (typeof window === "undefined") return "";
  return String(window.location.hostname || "").toLowerCase();
}

/** financing.goodleap.plus — toolkit at `/`, GoodLeap Plus apply at `/:id`. */
export function isFinancingPlusDomain() {
  return hostname() === "financing.goodleap.plus";
}

/**
 * Any goodleap.plus host (including financing. / www.).
 * Used by the apply flow for domain-aware UI (return URLs, branding).
 */
export function isGoodLeapPlusDomain() {
  return hostname().includes("goodleap.plus");
}

/**
 * Apex/www goodleap.plus only — marketing home at `/`.
 * Excludes financing.goodleap.plus so that host can use its own `/` route.
 */
export function isGoodLeapPlusMarketingDomain() {
  const h = hostname();
  if (!h.includes("goodleap.plus")) return false;
  if (isFinancingPlusDomain()) return false;
  return true;
}
